var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeries = function SvgSeries(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.5c-.275 0-.5.225-.5.5v12c0 .275.225.5.5.5h8c.275 0 .5-.225.5-.5V4c0-.275-.225-.5-.5-.5zM7 4c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v12c0 1.104-.897 2-2 2H9c-1.103 0-2-.896-2-2zm-3 .25c0-.415.334-.75.75-.75s.75.335.75.75v11.5c0 .416-.334.75-.75.75a.75.75 0 0 1-.75-.75zm-3 1.5c0-.415.334-.75.75-.75s.75.335.75.75v8.5c0 .416-.334.75-.75.75a.75.75 0 0 1-.75-.75z"
  })));
};
export default SvgSeries;